import React from 'react';

import { GeneralModal } from "components";

import { func_validation } from "functions";

import "assets/scss/components/modals/confirmationModal.scss";



export function ConfirmationModal(props) {
    // Props
    const { 
        className,
        headerClassName,

        isModalVisible,

        bodyHeader,
        description,

        bodyFooterClassName,
        input,

        cancelButtonText,
        confirmButtonText,
        isConfirmSuccessful,
        isActionLoading,

        confirmButtonProps,

        isWarning
    } = props;

    // Validate Props
    let bodyHeader_validated = func_validation.isNotNullUndefined(bodyHeader)? bodyHeader: "";
    let description_validated = func_validation.isNotNullUndefined(description)? description: "";
    let input_validated = func_validation.isNotNullUndefined(input)? input: "";
    let cancelButtonText_validated = func_validation.isStringTrimNotEmpty(cancelButtonText)? cancelButtonText: "";
    let confirmButtonText_validated = func_validation.isStringTrimNotEmpty(confirmButtonText)? confirmButtonText: "";

    return (
        <GeneralModal
            modalWapperClassName={"component-confirmationModal " +
                (className? className + " ":"")}
            isModalVisible={isModalVisible}
            updateParentState={props.updateParentState}

            // Header

            headerClassName={"component-confirmationModal-header " +
                (headerClassName? headerClassName + " ":"") +
                (isWarning? "component-confirmationModal-header__warning ":"")}
            headerCloseClassName={"component-confirmationModal-header-close"}
            isCloseIconInverse


            // Body

            bodyClassName={"component-confirmationModal-body"}
            bodyWrapperClassName={"component-confirmationModal-bodyWrapper"}

            bodyHeaderClassName={"component-confirmationModal-bodyHeader"}
            bodyHeader={bodyHeader_validated}

            contentClassName={"component-confirmationModal-description"}
            content={description_validated}

            bodyFooterClassName={"component-confirmationModal-input " + 
                (bodyFooterClassName? bodyFooterClassName + " ":"")}
            bodyFooter={input_validated}


            // Footer
            footerClassName={"component-confirmationModal-footer"}
            footerCancelWrapperClassName={"component-confirmationModal-footer-cancelWrapper"}
            footerCancelClassName={"component-confirmationModal-footer-cancel"}
            footerConfirmWrapperClassName={"component-confirmationModal-footer-confirmWrapper"}
            footerConfirmClassName={"component-confirmationModal-footer-confirm"}
            cancelButtonText={cancelButtonText_validated}
            handleOnCancel={props.handleOnCancel}
            isCancelButtonVisible

            confirmButtonText={confirmButtonText_validated}
            handleOnConfirm={props.handleOnConfirm}
            isConfirmSuccessful={isConfirmSuccessful}
            confirmButtonProps={{ 
                ...confirmButtonProps,
                isLoading: isActionLoading 
            }}
            isConfirmButtonVisible isToggleBeforeSubmissionNotRequired
        />
    )
}